/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2018, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @interface GlobalFiltersAPI
 * @classdesc API class that is used to control global filters.
 * @example dashboard.getFeature('GlobalFilters')
 */
define([], () => {
	class GlobalFiltersAPI {

		/**
		 * @function GlobalFiltersAPI#getFilters
		 * @description Gets a FilterAPI from the specified context.
		 * @param {String} source Datasource ID; defaults to the first datasource.
		 * @param {String} scope Defaults to 'global', i.e. "all tabs". Provide a page ID for "this tab".
		 * @public
		 *
		 * @returns {FilterAPI}
		 *
		 */
		getFilters(/* sourceId, scope */) {}

		/**
		 * @function GlobalFiltersAPI#getFilterList
		 * @description Gets the list of final resolved filters.
		 * @private
		 * @param {Object} selectors Object describing the filters to retrieve
		 * @param {String} [widgetId] Widget ID to determine the context of filters
		 * @returns {Object[]} Array of filters
		 *
		 */
		getFilterList(/* selector, widgetId */) {}

		/**
		 * @public
		 * @function GlobalFiltersAPI#removeFilters
		 * @description Removes all existing filters from the dashboard matching the given selectors.
		 * @param {Object} selectors Object describing the filters to remove. If not specified, all filters will be removed.
		 * @param {TransactionToken} [transactionToken] Transaction token
		 * @param {Object} [options]
		 * @returns {boolean} Returns true if any filters were successfully removed.
		 * @example
		 * filterApi.removeFilters({
		 *     scope: 'global' // all tabs
		 * }, transactionToken);
		 */
		removeFilters(/* selectors, transactionToken, options */) {}

		/**
		 * @public
		 * @function GlobalFiltersAPI#clearFilters
		 * @description Clears all existing filter values from the dashboard matching the given selectors.
		 * @param {Object} selectors Object describing the filters to clear of values
		 * @param {TransactionToken} [transactionToken] Transaction token
		 * @returns {boolean} Returns true if any filter values were successfully cleared.
		 * @example
		 * filterApi.clearFilters({
		 *     scope: 'model0000016428911c88_00000001' // single tab
		 * }, transactionToken);
		 */
		clearFilters(/* selectors, transactionToken */) {}


	}

	return GlobalFiltersAPI;
});
